import { render, staticRenderFns } from "./device-setup.vue?vue&type=template&id=2fc40e20&scoped=true&"
import script from "./device-setup.vue?vue&type=script&lang=ts&"
export * from "./device-setup.vue?vue&type=script&lang=ts&"
import style0 from "./device-setup.vue?vue&type=style&index=0&id=2fc40e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc40e20",
  null
  
)

export default component.exports